export const bankIdRequests = {
  LOGIN: 'login',
  SIGN_DOCUMENT: 'sign-document',
};

export const bankIdTypes = {
  SAME_DEVICE: 'sameDevice',
  OTHER_DEVICE: 'otherDevice',
};

export const BANK_ID_TIMEOUT = 5 * 60 * 1000; // 5 minutes in milliseconds
